module.exports = __webpack_public_path__ + "static/media/prtsa.252c9b06.png";